import {useDisclosure} from '@mantine/hooks';
import {useState} from 'react';
import {
  showErrorSnackBar,
  showSuccessSnackBar,
} from '../../../shared/components';
import {useProgressStepDeletionActions} from './useProgressStepDeletionActions';

/**
 * 削除対象のステップ情報を表す型
 */
type StepToDelete = {
  entryManagementId: number;
  stepId: number;
};

/**
 * 削除モーダルの状態管理と削除処理を統合管理するカスタムフック
 */
export const useProgressDeleteModal = () => {
  const [deleteModalOpened, {open: openDeleteModal, close: closeDeleteModal}] =
    useDisclosure(false);

  const [stepToDelete, setStepToDelete] = useState<StepToDelete | null>(null);

  const {executeStepDeletion} = useProgressStepDeletionActions();

  /**
   * 削除モーダルを開く
   * @param stepId - 削除対象のステップID
   * @param entryManagementId - エントリー管理ID（nullの場合はエラー表示）
   */
  const handleOpenDeleteModal = (
    stepId: number,
    entryManagementId: number | null | undefined,
  ) => {
    if (!entryManagementId) {
      showErrorSnackBar({
        title: '削除エラー',
        message: 'エントリー管理が選択されていないため、削除できません',
      });
      return;
    }
    setStepToDelete({entryManagementId, stepId});
    openDeleteModal();
  };

  /**
   * 削除を確定して実行する
   */
  const handleConfirmDelete = () => {
    if (!stepToDelete) {
      showErrorSnackBar({
        title: '削除エラー',
        message: '削除対象のステップ情報が見つかりません',
      });
      return;
    }

    executeStepDeletion(stepToDelete, {
      onSuccess: () => {
        showSuccessSnackBar({
          title: '削除完了',
          message: 'ステップを削除しました',
        });
        closeDeleteModal();
        setStepToDelete(null);
      },
      onError: () => {
        showErrorSnackBar({
          title: '削除失敗',
          message: 'ステップの削除に失敗しました。もう一度お試しください',
        });
      },
    });
  };

  return {
    deleteModal: {
      opened: deleteModalOpened,
      open: openDeleteModal,
      close: closeDeleteModal,
    },
    handleOpenDeleteModal,
    handleConfirmDelete,
  };
};
